import { render, staticRenderFns } from "./imgMessage.vue?vue&type=template&id=13e766f4&scoped=true"
import script from "./imgMessage.vue?vue&type=script&lang=js"
export * from "./imgMessage.vue?vue&type=script&lang=js"
import style0 from "./imgMessage.vue?vue&type=style&index=0&id=13e766f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e766f4",
  null
  
)

export default component.exports